import React from 'react';

import { formatDate } from 'lib/helpers/dateUtils';
import { ia } from 'lib/helpers/utility';
import useTimezone from 'lib/hooks/useTimezone';

import Avatar from 'components/shared/Avatar/Avatar';
import Typography from 'components/shared/Typography/Typography';

import { getArticle } from '../../../lib/helpers';
import { ACTION_MAP } from '../lib/constants';
import { useActivityCreator } from '../lib/useActivityCreator';

import ActivityContent from './ActivityContent';
import AppointmentDetail from './custom/AppointmentDetail';

const CUSTOM_CONTENT = { appointment: AppointmentDetail };

const ActivityLog = ({ category, activity }) => {
  const timezone = useTimezone();

  const { created_at, prefix = '', formattedChanges, action, isNestedCreate } = activity;

  const { displayName, avatarProps } = useActivityCreator(activity);

  const actionLabel = ACTION_MAP[isNestedCreate ? 'create' : action];
  const entityLabel = prefix || category || 'record';
  const isCreateRecord = action === 'create';
  const isDeleteRecord = action === 'delete';

  const showEntityLine = isCreateRecord || isDeleteRecord;
  const CustomContent = CUSTOM_CONTENT[activity.customContentType];

  return (
    <div className="flex flex-col gap-2">
      <div className="flex items-center gap-2">
        <div className="flex flex-1 items-center gap-1">
          <Avatar
            isSquare={false}
            size="small"
            className="!h-[18px] !min-h-[18px] !w-[18px] !min-w-[18px] shrink-0"
            {...avatarProps}
          />
          <p className="text-sm leading-[22px] text-neutral-600">
            <span className="font-medium text-neutral-800">{displayName} </span>
            {actionLabel && `${actionLabel}${showEntityLine || prefix ? '' : ': '}`}
            {showEntityLine ? (
              <span>
                {isCreateRecord
                  ? activity.entityDetail || activity.appointmentLink
                    ? ' a new'
                    : ' the'
                  : ` ${getArticle(entityLabel)}`}{' '}
                <span className="font-semibold text-neutral-800">{entityLabel}</span>
              </span>
            ) : (
              prefix && <span className="font-semibold text-neutral-800"> {prefix}</span>
            )}
          </p>
        </div>
        <Typography
          color="neutral-500"
          size="small"
          className="shrink-0 whitespace-nowrap leading-[22px]">
          {formatDate(created_at, timezone, 'h:mma')}
        </Typography>
      </div>

      {CustomContent ? (
        <CustomContent activity={activity} timezone={timezone} />
      ) : (
        !isCreateRecord &&
        ia(formattedChanges) && (
          <ActivityContent
            formattedChanges={formattedChanges}
            action={action}
            showOnlyNewValue={activity.showOnlyNewValue}
          />
        )
      )}
    </div>
  );
};

export default ActivityLog;
